// Slides that point at a control only some users have. TutorialProvider drops
// them from the tour (and from the step count startTutorial waits for) unless
// the matching entry in slideAccess is true, so no slide ever points at
// something that isn't on screen.
import { SMART_ASSIST_STEP_IDS } from './smartAssistSlides';

// The Point of Care card renders only for "va-site-swap" users whose launch
// sites load, which the tour can't tell from the flag alone, so
// PointOfCareLaunchSelector reports the outcome with this event.
export const POINT_OF_CARE_AVAILABILITY_EVENT = 'knowtex:point-of-care-availability';

export const POINT_OF_CARE_STEP_IDS = ['change_point_of_care', 'select_launch_site'];

export const LANGUAGE_MODEL_STEP_ID = 'choose_language_model';

const REQUIRED_ACCESS_BY_STEP = {
  ...Object.fromEntries(SMART_ASSIST_STEP_IDS.map((id) => [id, 'smartAssist'])),
  ...Object.fromEntries(POINT_OF_CARE_STEP_IDS.map((id) => [id, 'pointOfCare'])),
  [LANGUAGE_MODEL_STEP_ID]: 'languageModel',
};

/**
 * @typedef {{smartAssist?: boolean, pointOfCare?: boolean, languageModel?: boolean}} SlideAccess
 */

/**
 * @param {string} stepId
 * @param {SlideAccess} slideAccess
 * @returns {boolean}
 */
export const isStepAvailable = (stepId, slideAccess) => {
  const requiredAccess = REQUIRED_ACCESS_BY_STEP[stepId];
  return !requiredAccess || Boolean(slideAccess?.[requiredAccess]);
};

/**
 * Counts the steps this user will actually be shown.
 * @param {Array<{id: string}>} steps
 * @param {SlideAccess} slideAccess
 * @returns {number}
 */
export const countVisibleSteps = (steps, slideAccess) =>
  (steps || []).filter((step) => isStepAvailable(step.id, slideAccess)).length;
